var map = {
	"../pages/about/about.module": [
		195
	],
	"../pages/advanced-search/advanced-search.module": [
		197
	],
	"../pages/combined-results/combined-results.module": [
		223
	],
	"../pages/drug-category/drug-category.module": [
		224
	],
	"../pages/drug-detail/drug-detail.module": [
		226
	],
	"../pages/impressum/impressum.module": [
		225
	],
	"../pages/terms-and-conditions/terms-and-conditions.module": [
		227
	],
	"../pages/transfer-data/transfer-data.module": [
		228
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 194;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 194
// module chunks = 0